import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Booking() {
	const [loading, setLoading] = useState(false);
	const { language } = useLanguage();

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		if (language === 'en') {
			toast.info('Sending your message...', {
				position: 'top-right',
				autoClose: false, // Keeps the toast open until manually closed
				closeOnClick: false,
			});
		} else {
			toast.info('Đang gửi...', {
				position: 'top-right',
				autoClose: false, // Keeps the toast open until manually closed
				closeOnClick: false,
			});
		}

		const form = e.target;

		emailjs
			.sendForm(
				'service_41uzv8j',
				'template_rzlufml',
				form,
				'3FD0gMPFOva0V7bna',
			)
			.then(
				(response) => {
					//   console.log('SUCCESS!', response.status, response.text);
					toast.dismiss();
					if (language === 'en') {
						toast.success('Message sent successfully!', {
							position: 'top-right',
							autoClose: 5000,
						});
					} else {
						toast.success('Đã gửi thành công!', {
							position: 'top-right',
							autoClose: 5000,
						});
					}
					form.reset();
				},
				(error) => {
					if (language === 'en') {
						toast.error(
							'Sorry, error occur please send direct message in contact',
							{
								position: 'top-right',
								autoClose: 5000,
							},
						);
					} else {
						toast.error(
							'Đã có lỗi khi gửi, xin vui lòng sử dụng thông tin trong liên hệ',
							{
								position: 'top-right',
								autoClose: 5000,
							},
						);
					}
				},
			)
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<ToastContainer />

			{language === 'en' ? (
				<>
					<section className='p-6 dark:text-gray-50 cochin'>
						<form encType='multipart/form-data' onSubmit={handleSubmit}>
							<fieldset className='grid grid-cols-4 gap-6 p-6'>
								<div className='space-y-2 col-span-full lg:col-span-1'>
									<h1 className='text-2xl font-large text-darkBrown arial'>
										Book An Appointment
									</h1>
									<p className='text-md text-lightBrown'>
										To book an appointment, please fill out this form
									</p>
								</div>
								<div className='grid grid-cols-6 gap-4 col-span-full lg:col-span-3'>
									<div className='col-span-full sm:col-span-3'>
										<label
											htmlFor='fullName'
											className='text-sm text-lightBrown'>
											Full name
										</label>
										<input
											name='name'
											id='fullName'
											type='text'
											placeholder='Full name'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-3'>
										<label htmlFor='email' className='text-sm text-lightBrown'>
											Email
										</label>
										<input
											name='email'
											id='email'
											type='email'
											placeholder='Email'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-3'>
										<label
											htmlFor='phoneNumber'
											className='text-sm text-lightBrown'>
											Phone number
										</label>
										<input
											name='phoneNumber'
											id='phoneNumber'
											type='text'
											placeholder='Phone number'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full'>
										<label htmlFor='idea' className='text-sm text-lightBrown'>
											Idea
										</label>
										<input
											name='idea'
											id='idea'
											type='text'
											placeholder='Idea'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label htmlFor='size' className='text-sm text-lightBrown'>
											Size (centimeter)
										</label>
										<input
											name='size'
											id='size'
											type='text'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label
											htmlFor='expectedDay'
											className='text-sm text-lightBrown'>
											Expected Day
										</label>
										<input
											name='expectedDay'
											id='expectedDay'
											type='date'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label htmlFor='color' className='text-sm text-lightBrown'>
											Color or Black&Grey
										</label>
										<input
											name='color'
											id='color'
											type='text'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full'>
										<label
											htmlFor='message'
											className='text-sm text-lightBrown'>
											Message
										</label>
										<textarea
											name='message'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'></textarea>
									</div>

									<div className='col-span-full'>
										<button
											type='submit'
											className='px-4 py-2 font-medium text-white bg-brown rounded-md hover:bg-darkBrown focus:ring focus:ring avenir'
											disabled={loading}>
											Send
										</button>
									</div>
								</div>
							</fieldset>
						</form>
					</section>
				</>
			) : (
				<>
					<section className='p-6 dark:text-gray-50 cochin'>
						<form encType='multipart/form-data' onSubmit={handleSubmit}>
							<fieldset className='grid grid-cols-4 gap-6 p-6'>
								<div className='space-y-2 col-span-full lg:col-span-1'>
									<h1 className='text-2xl font-large text-darkBrown arial'>
										Đặt Hẹn
									</h1>
									<p className='text-md text-lightBrown'>
										Để đặt lịch hẹn, xin bạn vui lòng điền vào đơn
									</p>
								</div>
								<div className='grid grid-cols-6 gap-4 col-span-full lg:col-span-3'>
									<div className='col-span-full sm:col-span-3'>
										<label
											htmlFor='fullName'
											className='text-sm text-lightBrown'>
											Họ và Tên
										</label>
										<input
											name='name'
											id='fullName'
											type='text'
											placeholder='Nguyễn Văn A'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-3'>
										<label htmlFor='email' className='text-sm text-lightBrown'>
											Email
										</label>
										<input
											name='email'
											id='email'
											type='email'
											placeholder='Email'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-3'>
										<label
											htmlFor='phoneNumber'
											className='text-sm text-lightBrown'>
											Số điện thoại
										</label>
										<input
											name='phoneNumber'
											id='phoneNumber'
											type='text'
											placeholder='Phone number'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full'>
										<label htmlFor='idea' className='text-sm text-lightBrown'>
											Ý tưởng
										</label>
										<input
											name='idea'
											id='idea'
											type='text'
											placeholder='Idea'
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label htmlFor='size' className='text-sm text-lightBrown'>
											Kích thước (centimeter)
										</label>
										<input
											name='size'
											id='size'
											type='text'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label
											htmlFor='expectedDay'
											className='text-sm text-lightBrown'>
											Ngày xăm
										</label>
										<input
											name='expectedDay'
											id='expectedDay'
											type='date'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full sm:col-span-2'>
										<label htmlFor='color' className='text-sm text-lightBrown'>
											Màu hay Trắng đen
										</label>
										<input
											name='color'
											id='color'
											type='text'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'
										/>
									</div>
									<div className='col-span-full'>
										<label
											htmlFor='message'
											className='text-sm text-lightBrown'>
											Lời nhắn
										</label>
										<textarea
											name='message'
											placeholder=''
											className='p-1 w-full rounded-md focus:ring focus:ring focus:ring border border-lightBrown text-gray-400'></textarea>
									</div>

									<div className='col-span-full'>
										<button
											type='submit'
											className='px-4 py-2 font-medium text-white bg-brown rounded-md hover:bg-darkBrown focus:ring focus:ring avenir'
											disabled={loading}>
											Gửi
										</button>
									</div>
								</div>
							</fieldset>
						</form>
					</section>
				</>
			)}
		</>
	);
}

export default Booking;
